module.exports = __WEBPACK_EXTERNAL_MODULE_196__;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 196
// module chunks = 9